exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.task-documents[data-v-34f58b4f] {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -10px;\n  margin-right: -10px;\n}\n.task-documents__item[data-v-34f58b4f] {\n  width: 100%;\n  padding: 0 10px 20px 10px;\n}\n@media (min-width: 768px) {\n.task-documents__item[data-v-34f58b4f] {\n    width: 50%;\n}\n}\n", ""]);

// exports
